import { TFunction } from "i18next";
import * as Yup from "yup";

import { ExchangeRequestedServicesValues } from "@/pages/exchange/Exchange.types";
import { exchangeRequestedServicesRules } from "@/pages/exchange/Exchange.utils";

export function editExchangeRequestValidationSchema(t: TFunction): Yup.ObjectSchema<ExchangeRequestedServicesValues> {
  return Yup.object(exchangeRequestedServicesRules(t));
}
